import { client } from '../../../../../common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '../../../../../common-utils/functions/restUtils';

/**
 * @param data
 * @returns {Array}
 */
function mapResponseData(data) {
    return data;
}

const queryGetAlertReceivers = (organizationId, enabled) => {
    return {
        queryKey: [ORGANIZATION.SIM_ALERTS_RECEIVERS.queryKey, organizationId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(ORGANIZATION.ALERTS.url, { organizationId: organizationId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetAlertReceivers;
